import * as React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import TermsAndConditions from '../../../../components/home/TermsAndConditions/TnCContent'

const StyledTermsAndConditions = styled(TermsAndConditions)`
  padding: 1rem;
`

function MainView(props) {
  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
            display: none !important;
          }`}
        </style>
      </Helmet>
      <StyledTermsAndConditions />
    </>
  )
}

export default MainView
